import { GenericNode, GetNodeWithState } from '../types'

type NodeData = GenericNode<GetNodeWithState<Record<string, unknown>>>

export const getCheckedNodeIds = <N extends NodeData>({
    nodes,
    getNodeChildren,
}: {
    nodes: N[]
    getNodeChildren: (node: N) => N[]
}): string[] => {
    const checkedAndIndeterminateNodeIds: string[] = []

    function traverse(node: N): void {
        const children = getNodeChildren(node)
        const nodeId = String(node.nodeId)

        if (node.state === 'checked') {
            checkedAndIndeterminateNodeIds.push(nodeId)
        }
        if (children.length === 0) {
            return
        }

        // Recursively process children
        children.forEach((child) => {
            traverse(child)
        })
    }

    nodes.forEach((child) => {
        traverse(child)
    })
    return checkedAndIndeterminateNodeIds
}
